import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss']
})
export class EventDetailsComponent implements OnInit {
  @Input()
  data;
  @Input()
  lg;
  @Input()
  toBuy: boolean;

  @Output()
  isClose = new EventEmitter();
  event_details = [];
  constructor(
    private authService: AuthService,
    private toastrService: ToastrService,
    public router: Router
  ) {}

  ngOnInit() {
    // this.ngbActiveModal.close();
    if (this.data) {
      const details = this.data.eventDetails.details;
      this.event_details = [];
      for (const i in details) {
        if (this.lg === details[i].lg) {
          this.event_details.push(details[i]);
        }
      }
      if (this.toBuy) {
        setTimeout(() => {
          this.scroll('types');
        }, 1000);
      }
      // $.getScript('./assets/js/customizer.js');
    }
    // console.log(this.data);
  }

  scroll(id) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }
  click(id) {
    const el = document.getElementById(id);
    el.click();
  }

  buy(type) {
    if (this.data.status) {
      let warningMss = '';
      let pls = '';
      if (this.lg === 'th') {
        warningMss = 'เข้าสู่ระบบ';
        pls = 'กรุณา!';
      } else {
        warningMss = 'Sing In';
        pls = 'Please!';
      }
      // console.log(this.authService.userAuthenticated);
      if (this.authService.userAuthenticated) {
        this.isClose.emit(true);
        if (this.data.type === 'c') {
          this.router.navigate([
            'user/booking',
            {
              eventId: this.data.id
            }
          ]);
        } else {
          this.router.navigate([
            'user/ordering',
            {
              eventId: this.data.id
            }
          ]);
        }
      } else {
        this.toastrService.warning(warningMss, pls);
        this.click('singin');
      }
    } else {
      let warningMss = '';
      let pls = '';
      if (this.lg === 'th') {
        warningMss = 'ยังไม่มีการเปิดให้ลงทะเบียนรายการนี้';
        pls = 'ขออภัย!';
      } else {
        warningMss = 'This item is not yet open.';
        pls = 'Sorry!';
      }
      this.toastrService.warning(warningMss, pls);
    }
  }
}
